import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("gidza_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => localStorage.removeItem("gidza_token")).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("gidza_token", r.data.token); setUser(r.data.user);
    return r.data.user;
  };
  const register = async (data) => {
    const r = await api.post("/auth/register", data);
    localStorage.setItem("gidza_token", r.data.token); setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => { localStorage.removeItem("gidza_token"); setUser(null); };
  const refresh = async () => { const r = await api.get("/auth/me"); setUser(r.data); return r.data; };

  return <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
